/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
import React from 'react';
import PropTypes from 'prop-types';

function NumberToWords({ number }) {
  const ones = [
    '',
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
  ];
  const teens = [
    '',
    'eleven',
    'twelve',
    'thirteen',
    'fourteen',
    'fifteen',
    'sixteen',
    'seventeen',
    'eighteen',
    'nineteen',
  ];
  const tens = [
    '',
    'ten',
    'twenty',
    'thirty',
    'forty',
    'fifty',
    'sixty',
    'seventy',
    'eighty',
    'ninety',
  ];
  const thousands = ['', 'thousand', 'million', 'billion', 'trillion'];

  const tripletToWords = (num) => {
    num = parseInt(num, 10);
    let words = '';

    if (num >= 100) {
      words += `${ones[Math.floor(num / 100)]} hundred `;
      num %= 100;
    }

    if (num >= 20) {
      words += `${tens[Math.floor(num / 10)]} `;
      num %= 10;
    } else if (num >= 10) {
      words += teens[num - 10];
      return words;
    }

    if (num > 0) {
      words += ones[num];
    }

    return words.trim();
  };

  const convertNumberToWords = (num) => {
    if (num === 0) {
      return 'zero';
    }

    const parts = [];
    while (num > 0) {
      parts.push(num % 1000);
      num = Math.floor(num / 1000);
    }

    let words = '';
    for (let i = parts.length - 1; i >= 0; i--) {
      if (parts[i] !== 0) {
        words += `${tripletToWords(parts[i])} ${thousands[i]} `;
      }
    }

    return words.trim();
  };

  const [integerPart, fractionalPart] = number
    .toString()
    .split('.')
    .map(Number);

  const integerWords = convertNumberToWords(integerPart);
  const fractionalWords = fractionalPart
    ? `and ${convertNumberToWords(fractionalPart)} paise`
    : '';

  return (
    <div>
      {integerWords} rupee{integerPart !== 1 ? 's' : ''} {fractionalWords} Only
    </div>
  );
}
NumberToWords.propTypes = {
  number: PropTypes.any.isRequired,
};
export default NumberToWords;
